var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgToolbarQueue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.46,9.4a4.3,4.3,0,0,1,2,3.2A3.4,3.4,0,0,0,22,13a3.5,3.5,0,1,0-3.49-3.54Zm-2.28,7.13a3.49,3.49,0,1,0-3.49-3.48,3.48,3.48,0,0,0,3.49,3.48Zm1.48.24h-3a4.47,4.47,0,0,0-4.46,4.47v3.68l.25.07a20.46,20.46,0,0,0,6.06,1,12.74,12.74,0,0,0,5.31-1l.23-.12h0V21.24A4.46,4.46,0,0,0,17.66,16.77Zm5.77-3.59H20.49a4.27,4.27,0,0,1-1.33,3A5.32,5.32,0,0,1,23,21.24v1.11a12,12,0,0,0,4.68-1l.23-.12h0v-3.6A4.47,4.47,0,0,0,23.43,13.18ZM10,13a3.44,3.44,0,0,0,1.85-.54,4.44,4.44,0,0,1,1.63-2.76V9.49A3.49,3.49,0,1,0,10,13Zm3.14,3.22a4.27,4.27,0,0,1-1.33-3H8.58a4.47,4.47,0,0,0-4.46,4.46v3.67l.25.08a21.16,21.16,0,0,0,5,.94V21.24a5.31,5.31,0,0,1,3.85-5.08Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToolbarQueue);
export default __webpack_public_path__ + "static/media/toolbar-queue.16ab76fd.svg";
export { ForwardRef as ReactComponent };